"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCustomScrollEventsHandlers = void 0;
/* eslint-disable sonarjs/no-redundant-jump */
/* eslint-disable no-param-reassign */
const bottom_sheet_1 = require("@gorhom/bottom-sheet");
const lodash_throttle_1 = __importDefault(require("lodash.throttle"));
const react_native_reanimated_1 = require("react-native-reanimated");
// Custom hook based on - https://github.com/gorhom/react-native-bottom-sheet/blob/master/src/hooks/useScrollEventsHandlersDefault.ts
// Reference issue - https://github.com/gorhom/react-native-bottom-sheet/issues/630
exports.useCustomScrollEventsHandlers = (scrollableRef, scrollableContentOffsetY, setScrollY) => {
    const { animatedSheetState, animatedScrollableState, animatedAnimationState, animatedScrollableContentOffsetY: rootScrollableContentOffsetY, } = bottom_sheet_1.useBottomSheetInternal();
    const throttledSetScrollYHandler = lodash_throttle_1.default((scrollY) => setScrollY(scrollY), 700, {
        trailing: true,
        leading: true,
    });
    const handleOnScroll = react_native_reanimated_1.useWorkletCallback((e, context) => {
        if (animatedSheetState.value === bottom_sheet_1.SHEET_STATE.EXTENDED ||
            animatedSheetState.value === bottom_sheet_1.SHEET_STATE.FILL_PARENT) {
            context.shouldLockInitialPosition = false;
        }
        if (animatedScrollableState.value !== bottom_sheet_1.SCROLLABLE_STATE.LOCKED) {
            react_native_reanimated_1.runOnJS(throttledSetScrollYHandler)(e.contentOffset.y);
        }
        if (animatedScrollableState.value === bottom_sheet_1.SCROLLABLE_STATE.LOCKED) {
            const lockPosition = context.shouldLockInitialPosition
                ? context.initialContentOffsetY ?? 0
                : 0;
            react_native_reanimated_1.scrollTo(scrollableRef, 0, lockPosition, false);
            scrollableContentOffsetY.value = lockPosition;
            react_native_reanimated_1.runOnJS(throttledSetScrollYHandler)(0);
            // eslint-disable-next-line no-useless-return
            return;
        }
    }, [
        scrollableRef,
        scrollableContentOffsetY,
        animatedScrollableState,
        animatedSheetState,
    ]);
    const handleOnBeginDrag = react_native_reanimated_1.useWorkletCallback(({ contentOffset: { y } }, context) => {
        scrollableContentOffsetY.value = y;
        rootScrollableContentOffsetY.value = y;
        context.initialContentOffsetY = y;
        if (animatedSheetState.value !== bottom_sheet_1.SHEET_STATE.EXTENDED &&
            animatedSheetState.value !== bottom_sheet_1.SHEET_STATE.FILL_PARENT &&
            y > 0) {
            context.shouldLockInitialPosition = true;
        }
        else {
            context.shouldLockInitialPosition = false;
        }
    }, [
        scrollableContentOffsetY,
        animatedSheetState,
        rootScrollableContentOffsetY,
    ]);
    const handleOnEndDrag = react_native_reanimated_1.useWorkletCallback(({ contentOffset: { y } }, context) => {
        if (animatedScrollableState.value === bottom_sheet_1.SCROLLABLE_STATE.LOCKED) {
            const lockPosition = context.shouldLockInitialPosition
                ? context.initialContentOffsetY ?? 0
                : 0;
            react_native_reanimated_1.scrollTo(scrollableRef, 0, lockPosition, false);
            scrollableContentOffsetY.value = lockPosition;
            return;
        }
        if (animatedAnimationState.value !== bottom_sheet_1.ANIMATION_STATE.RUNNING) {
            scrollableContentOffsetY.value = y;
            rootScrollableContentOffsetY.value = y;
        }
    }, [
        scrollableRef,
        scrollableContentOffsetY,
        animatedAnimationState,
        animatedScrollableState,
        rootScrollableContentOffsetY,
    ]);
    const handleOnMomentumEnd = react_native_reanimated_1.useWorkletCallback(({ contentOffset: { y } }, context) => {
        if (animatedScrollableState.value === bottom_sheet_1.SCROLLABLE_STATE.LOCKED) {
            const lockPosition = context.shouldLockInitialPosition
                ? context.initialContentOffsetY ?? 0
                : 0;
            react_native_reanimated_1.scrollTo(scrollableRef, 0, lockPosition, false);
            scrollableContentOffsetY.value = 0;
            return;
        }
        if (animatedAnimationState.value !== bottom_sheet_1.ANIMATION_STATE.RUNNING) {
            scrollableContentOffsetY.value = y;
            rootScrollableContentOffsetY.value = y;
        }
    }, [
        scrollableContentOffsetY,
        scrollableRef,
        animatedAnimationState,
        animatedScrollableState,
        rootScrollableContentOffsetY,
    ]);
    return {
        handleOnScroll,
        handleOnBeginDrag,
        handleOnEndDrag,
        handleOnMomentumEnd,
    };
};
